var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-frame-container"},[_c('iframe',{staticClass:"gameFrame",attrs:{"id":"gameFrame","src":this.gameUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }